export enum PaymentFrequency {
    everyFourDays = "efbee7ac-4b76-46c0-8ecc-8f6bf191abf6",
    everyThreeDays = "6f27dcd0-5720-4cb0-8164-cbea6c6357ca",
    everyTwoDays = "1f106211-6737-439a-8602-eb0788bcc51a",
    monthly = "4362a628-5293-4b93-a797-27591c28836b",
    weekly = "79d50581-e7d5-44f5-a693-a10ee4ed283f",
    yearly = "63fd67c0-033f-444f-b692-196794e3804a",
}
